<template>
  <el-button
    type="text"
    :icon="display === true ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" class="collapse-title"
    @click="clickAction"
  >
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  name: "collapse-title",
  props: {
    display: {
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    clickAction() {
      this.$emit("update:display", !this.display);
    },
  },
};
</script>

<style scoped lang="less">
  .collapse-title {
    font-size: 1.2rem;
    color: @other-grey;

    &:hover, &:focus {
      color: @primary-orange;
    }
  }
</style>